<template lang="pug">
  v-card(min-height="80vh")
    v-card-title.pa-0
      v-row.px-5.pt-3(no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].primary500}`")
        v-col.shrink
          v-btn.ml-n3(text icon @click="showModal = !showModal" height)
            eva-icon(name="close-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
        v-col.ml-3
          p.mb-0.h6.basic100--text Record New Expense

    v-card-text.px-0.pb-0(id="mainContainer")
      .by-amount(id="formDataValue")
        .pa-6(:style="{'background-color': $vuetify.theme.themes[$theme].primary500}")
          v-card(flat)
            v-layout.pa-4(@click="isMultyCategory? '' : openCalculatorInputDialog = true")
              div.mr-4.my-auto(style="height:24px")
                CashIcon(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].primary500 }")
              .h6.primary500--text {{ totalPrice | displayPrice }}
  
      v-form.py-6(ref="form")
        .px-6
          .label.basic600--text.text-uppercase(id="formDataDate") Date
          v-dialog(v-model='form.data.date.show' width='290px')
            template(v-slot:activator='{ on }')
              v-text-field.mt-2(:value="form.data.date.value" placeholder="Select date" outlined dense background-color="basic200" readonly v-on='on' :rules="rules.is_selected")
                template(v-slot:append)
                  eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-date-picker(v-model='form.data.record_date' color="primary" no-title @change="saveDate()")
          .label.basic600--text.text-uppercase(id="formDataCategory") Category (Required)
          v-select.mt-2(v-model="form.data.category" item-text="name" item-value="id" :items="categories" outlined dense background-color="basic200" placeholder="Select expense category" :rules="rules.is_selected" return-object :loading="isFetchingCategories")
            template(v-slot:append)
              eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

            template(v-slot:item="{ index, item, attrs }")
              v-layout
                v-list-item-content
                  v-list-item-title.s1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.name }}
                  v-list-item-subtitle.c1(v-if="item.description" :class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.description }}
        .px-6
          .categories-input(v-for="(item,index) in form.data.items" :key="index")
            v-divider.basic300.mb-6.mt-2(v-if="index != 0")
            v-layout
              .label.basic600--text.text-uppercase(:id="'formDataCategory' + index") Description
              v-spacer
              eva-icon(v-if="isMultyCategory" name ="trash-outline" width="16" height="16" :fill="$vuetify.theme.themes[$theme].danger500" @click="form.data.items.splice(index, 1)")
            v-text-field.mt-2(:id="'formDataDescription' + index" v-model='item.description' background-color="basic200" height="40" outlined dense placeholder="Write a description for this expense")

            .amount(v-if="isMultyCategory" :id="'formDataAmount' + index")
              .label.basic600--text.text-uppercase Amount
              v-text-field.mt-2(v-model='item.displayAmount' placeholder="0" dense outlined height="40" background-color="basic200" :prefix="$currency.symbol" :rules="rules.has_price" readonly @click="item.openDialog = true")

            CalculatorInput(v-if="item.openDialog" :open.sync="item.openDialog" :initial="item.amount" @input="handleInput($event, index)")

          div
            v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="clickAddNewCategory")
              eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
              span Add more

        v-divider.basic300.mt-4.mb-6
        .px-6
          .label.basic600--text.text-uppercase {{ recipientName }}
          v-text-field.mt-2.mb-6(:value="form.data.vendor.name" :placeholder="'Add ' + recipientName" outlined dense background-color="basic200" readonly hide-details @click="clickAddVendor()")
            template(v-slot:append)
              eva-icon(name="plus-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700" @click="clickAddVendor()")
          
          .label.basic600--text.text-uppercase Notes
          v-text-field.mt-2(v-model='form.data.notes' placeholder="Write notes here" background-color="basic200" hide-details outlined dense :maxlength="200")

        v-divider.basic300.my-4
        .px-6
          .payment-status.pt-2
            .label.basic600--text.text-uppercase Payment Status
            v-row.px-3.mb-4
              v-radio-group.mt-2(v-model='form.paymentStatus' row dense)
                v-radio.mb-4(value='paid' style="width:100%")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text Paid
                v-radio.mb-4(value='unpaid' style="width:100%")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text Unpaid
                v-radio(value='partial' style="width:100%")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text Partial Paid / Deposit
        v-divider.basic300.my-4
        .px-6
          .payment-method(v-if="form.paymentStatus == 'partial'" id="formPaymentAmount")
            .label.basic600--text.text-uppercase Amount paid
            v-text-field.mt-2(v-model='form.paymentAmount' placeholder="0" dense outlined height="40" background-color="basic200" type="number" :prefix="$currency.symbol"  :rules="priceRules")

          .payment-method(v-if="form.paymentStatus == 'paid' || form.paymentStatus == 'partial'" id="formPaymentMethod")
            .label.basic600--text.text-uppercase Payment Method
            v-row.px-3.mb-n2.mt-2
              v-radio-group.mt-2(v-model='form.paymentMethod' row dense)
                v-radio.mb-4(v-for="(method, index) in paymentMethods" :value="method.name" style="width:100%" :key="method.id")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text {{ method.name }}

          .payment-due-date(v-if="form.paymentStatus != 'paid'" id="formPaymentDueDate")
            .label.basic600--text.text-uppercase Payment due
            v-dialog(v-model='form.date.show' width='290px')
              v-date-picker(v-model='form.paymentDueDate' color="primary" no-title @change="saveDueDate()")
            v-select.mt-2(v-model="form.paymentDueDate" background-color="basic200" outlined dense hide-no-data hide-details :items="dueDateChoices" item-text="name" item-value="id")
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
          
          .document(v-if="form.paymentStatus != 'unpaid'")
            v-row.mt-4(no-gutters align="center")
              v-col.shrink
                v-img.mr-4(:src="form.documentImage.url ? form.documentImage.url : require('@/assets/image_placeholder.png')" width="95px" aspect-ratio="1")
              v-col
                div.file-layout
                  v-btn.button-AA-tiny.text-uppercase(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}") upload image
                  input.input-layout(type="file" @change="onFileChange" accept="image/*")
                div.c1.basic600--text.mt-4 Upload photo of your
                  span(v-if="form.paymentStatus == 'paid'")  receipt
                  span(v-else)  invoice

    v-card-actions
      v-spacer
      v-btn(color='white', text @click='showModal = false')
        .button-Aa-medium.primary400--text Cancel
      v-btn.mr-2(color='info500' depressed @click="clickProceed()" :loading="loading")
        .button-AA-medium.basic100--text {{ $t('save') }}

    .modals
      CalculatorInput(v-if="openCalculatorInputDialog" :open.sync="openCalculatorInputDialog" :initial="form.data.items[0].amount" @input="handleInput($event, 0)")
      AddVendors(v-if="openAddVendorsDialog" :open.sync="openAddVendorsDialog" :defaultVendor="selectedVendor" @confirm="updateVendor")
      y-dialog(v-if="openSelectVendorTypeDialog" v-model='openSelectVendorTypeDialog', max-width='400')
        v-card.basic300
          v-card-title.h6.basic800--text.px-4 Select recipient type
          v-card-text.p2.primary500--text.px-4
            v-list.pa-0
              div(v-for='(vendor, index) in selectedVendorCategory')
                v-divider(v-if="index != 0")
                v-list-item(:key='vendor.id' @click="clickSelectVendor(vendor)")
                  div {{ vendor.name }}
      
</template>

<script>
import { DateTime } from 'luxon'
import { mapActions, mapGetters } from 'vuex'
import CalculatorInput from '@/components/yezzabook/dialogs/CalculatorInput.vue'
import AddVendors from '@/components/yezzabook/dialogs/expense/AddVendors.vue'
import { resizeImage } from '@/utils'

export default {
  name: 'RecordIncome',
  props: ['open', 'step', 'loading'],
  components: { CalculatorInput, AddVendors },
  data: () => ({
    isLoading: false,
    isFetchingCategories: true,
    openCalculatorInputDialog: false,
    openSelectVendorTypeDialog: false,
    openAddVendorsDialog: false,
    form: {
      // expense
      type: 'amount',
      data: {
        category: null,
        items: [
          {
            amount: 0,
            displayAmount: 0,
            description: null,
            openDialog: false
          }
        ],
        record_date: null,
        notes: null,
        date: {
          show: false,
          value: null
        },
        vendor: {
          name: null
        }
      },
      // payment
      paymentStatus: 'paid',
      paymentMethod: null,
      paymentDueDate: null,
      paymentAmount: null,
      date: {
        show: false,
        value: null
      },
      documentImage: {
        url: '',
        file: null,
      }
    },
    categories: [],
    defaultVendors: [],
    selectedVendor: null,
    paymentMethods: [],
    dueDateChoices: [],
    originalDateChoices: [],
    options: {
      duration: 200,
      offset: 0,
      easing: 'linear',
      container: '#mainContainer'
    },
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      is_selected: [(v) => v !== null || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v > 0|| 'This field is required'],
      has_price: [(v) => !!v || 'This field is required', (v) => parseInt(v) > 0|| 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    totalPrice () {
      let total = 0
      this.form.data.items.forEach(o => {
        total += parseInt(o.amount)
      })
      return total
    },
    priceRules () {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required',
        v => v <= this.totalPrice/this.$currency.multiplier || `Amount should not be above ${this.$currency.symbol} ${(parseFloat(this.totalPrice/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
      ]
    },
    isMultyCategory() {
      return this.form.data.items.length > 1
    },
    selectedVendorCategory () {
      let selected = []
      if (this.form.data.category) {
        this.defaultVendors.forEach(vendor => {
          if (this.form.data.category.id === vendor.category) {
            const exist = selected.find((item) => item.id === vendor.id)
            if (!exist) {
              selected.push(vendor)
            }
          }
        })
      }
      if (selected.length == 0) {
        this.defaultVendors.forEach(vendor => {
          if (vendor.name.toLowerCase() === 'recipient') {
            selected.push(vendor)
          }
        })
      }
      return selected
    },
    recipientName () {
      if (this.defaultVendors.length === 0) {
        return 'Recipient'
      }
      return this.selectedVendorCategory[0].name
    }
  },
  watch: {
    'form.data.category' () {
      this.form.data.vendor = { name: null }
    },
    'form.data.record_date' () {
      this.form.paymentDueDate = this.form.data.record_date
      const selectedDate = DateTime.fromFormat(this.form.data.record_date, 'yyyy-MM-dd')
      this.originalDateChoices = [
        { name: `Due ${selectedDate.toFormat('dd/MM/yyyy')}`, id: selectedDate.toFormat('yyyy-MM-dd') },
        { name: 'Within 15 days', id: selectedDate.plus({ days: 15 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 30 days', id: selectedDate.plus({ days: 30 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 45 days', id: selectedDate.plus({ days: 45 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 60 days', id: selectedDate.plus({ days: 60 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 90 days', id: selectedDate.plus({ days: 90 }).toFormat('yyyy-MM-dd') },
        { name: 'Custom', id: 'custom'}
      ]
      this.dueDateChoices = [ ...this.originalDateChoices ]
    },
    'form.paymentDueDate' (val) {
      if (val === 'custom') {
        this.form.date.show = true
        this.form.paymentDueDate = this.form.data.record_date
      }
      if (val) {
        this.dueDateChoices = [ ...this.originalDateChoices ]
        this.dueDateChoices.push({ name: this.formatDate(this.form.paymentDueDate), id: this.form.paymentDueDate})
      } else {
        this.dueDateChoices = [ ...this.originalDateChoices ]
      }
    }
  },
  mounted () {
    this.form.data.record_date = DateTime.local().toFormat('yyyy-MM-dd')
    this.form.data.date.value = this.formatDate(this.form.data.record_date)
    this.fetchCategories()
    this.fetchDefaultVendors()
    this.getPaymentMethods()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchCategories () {
      this.$axios.get(`/books/${this.company.slug}/expense_categories`)
        .then((response) => {
          this.isFetchingCategories = false
          this.categories = response.data.results
        }).catch(() => {})
    },
    fetchDefaultVendors () {
      this.$axios.get(`/books/${this.company.slug}/vendors?&default=true`)
        .then((response) => {
          this.defaultVendors = response.data.results
        }).catch(() => {})
    },
    handleInput (val, index) {
      this.form.data.items[index].amount = (parseFloat(val)).toFixed(this.$currency.exponent).replace('.', '')
      this.form.data.items[index].displayAmount = this.$options.filters.displayPriceRaw(this.form.data.items[index].amount)
    },
    clickAddNewCategory () {
      this.form.data.items.push(
        {
          amount: 0,
          displayAmount: 0,
          description: null,
          openDialog: false
        }
      )
    },
    clickAddVendor () {
      if (this.selectedVendorCategory.length > 1) {
        this.openSelectVendorTypeDialog = true
        return
      }
      this.selectedVendor = this.selectedVendorCategory[0]
      this.openAddVendorsDialog = true
    },
    clickSelectVendor (vendor) {
      this.selectedVendor = vendor
      this.openAddVendorsDialog = true
      this.openSelectVendorTypeDialog = false
    },
    updateVendor (val) {
      this.form.data.vendor = val
    },
    saveDate () {
      this.form.data.date.show = false
      this.form.data.date.value = this.formatDate(this.form.data.record_date)
    },
    saveDueDate () {
      this.form.date.show = false
      this.form.date.value = this.formatDate(this.form.paymentDueDate)
    },
    getPaymentMethods () {
      this.isLoading = true
      this.$axios.get(`/books/${this.company.slug}/payment_methods`).then((response) => {
        this.isLoading = false
        this.paymentMethods = [...response.data.results]
        this.form.paymentMethod = response.data.results.filter(method => method.name.toLowerCase() === 'bank transfer')[0]
        if (!this.form.paymentMethod) {
          this.form.paymentMethod = this.paymentMethods[0].name
        } else {
          this.form.paymentMethod = this.form.paymentMethod.name
        }  
      }).catch(() => {})
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clickProceed () {
      let finalData = {}
      // generate expense object
      let data = {}
      if (!this.totalPrice && !this.isMultyCategory) {
        this.showMessage(['error', this.$t('error_message.amount_is_required')])
        this.$vuetify.goTo('#formDataValue', this.options)
        return
      }
      this.$refs.form.validate()
      if (!this.form.data.category) {
        this.showMessage(['error', `Category is required`])
        this.$vuetify.goTo('#formDataCategory', this.options)
        return
      }
      data.display_category = this.form.data.category.name
      data.category = this.form.data.category.id

      for (let index = 0; index < this.form.data.items.length; index++) {
        const item = this.form.data.items[index]
        let messageIndex = ''
        if (this.isMultyCategory) {
          messageIndex = `for expence category ${index + 1} `
        }
        if (!item.amount || item.amount === '000') {
          this.showMessage(['error', `Amount ${messageIndex}is required`])
          this.$vuetify.goTo('#formDataAmount' + index, this.options)
          return
        }
      }
      data.items = this.form.data.items.map((m) => {
        return {
          amount: m.amount,
          description: m.description
        }
      })

      if (!this.form.data.record_date) {
        this.showMessage(['error', this.$t('error_message.date_is_required')])
        this.$vuetify.goTo('#formDataDate', this.options)
        return
      }
      data.record_date = this.form.data.record_date
      if (this.form.data.notes) {
        data.notes = this.form.data.notes
      }
      if (this.form.data.vendor.name && this.form.data.vendor.name !== 'None') {
        data.display_vendor = '-'
        if (this.form.data.vendor.name !== 'None') {
          data.vendor = this.form.data.vendor.id
          data.display_vendor = this.form.data.vendor.name
        }
      }
      if (this.form.paymentDueDate && (this.form.paymentStatus == 'unpaid' || this.form.paymentStatus == 'partial')) {
        data.due_at = this.form.paymentDueDate
      }
      finalData.expense = { ...data }
      data = {}

      // generate payment object
      if (!this.form.paymentMethod && (this.form.paymentStatus == 'paid' || this.form.paymentStatus == 'partial')) {
        this.showMessage(['error', this.$t('error_message.payment_method_required')])
        this.$vuetify.goTo('#formPaymentMethod', this.options)
        return
      }
      if (this.form.paymentMethod && (this.form.paymentStatus == 'paid' || this.form.paymentStatus == 'partial')) {
        data.payment_method = this.form.paymentMethod
        data.paid_date = this.form.data.record_date
      }
      if (this.form.paymentStatus == 'partial' && this.form.paymentAmount) {
        data.amount = (parseFloat(this.form.paymentAmount)).toFixed(this.$currency.exponent).replace('.', '')
      } else if (this.form.paymentStatus == 'paid') {
        data.amount = this.amountDue
      }
      finalData.payment = { ...data }
      data = {}

      if (this.form.documentImage.file) {
        finalData.document = {
          doc_type: this.form.paymentStatus == 'paid'? 'receipt' : 'invoice',
          file: this.form.documentImage.file
        }
      }
      data = {}

      this.$emit('proceed', finalData)
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'expense_image.jpeg')
      this.form.documentImage.url = resizedImage.dataURL
      this.form.documentImage.file = resizedImage.file
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
.file-layout {
  position: relative;
  cursor: pointer;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "save": "Save"
  }
}
</i18n>
